import { Header as HeaderBase } from 'shared';
import styled, { from, to } from 'theme';

export const Header = styled(HeaderBase)`
  ${from('lg')} {
    .header__nav-list {
      display: none;
    }
  }
`;

export const HeaderTitle = styled.div`
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${props => props.theme.variables.fonts.size.bigger1};
  font-weight: ${props => props.theme.variables.fonts.weight.bold};
  border-left: 0.0625rem solid ${props => props.theme.variables.customColors.lightGreyText};
  color: ${props => props.theme.variables.customColors.textColor};
  height: 3.75rem;
  display: flex;
  align-items: center;
  margin: -0.5rem 2rem -0.5rem 2rem;
  padding-left: 2rem;

  ${to('lg')} {
    display: none;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;

  span {
    display: none;

    ${from('md')} {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 1.25rem;
      max-width: 15rem;
      color: ${props => props.theme.variables.customColors.lightNavy};
      font-family: ${props => props.theme.variables.typography.secondaryFont};
      display: block;
    }
  }

  .button {
    justify-content: center;
    display: flex;
    margin-left: 2rem;
    background-color: ${props => props.theme.variables.customColors.lightNavy};

    > div {
      line-height: 2rem;
    }
  }
`;
